import React from 'react';
import {elementsItems,scmTagElements} from '../../elementsItems';
import Icons from '../../../Icons/Icons';
import {isSet} from '../../../../Utils/CommonFunctions';

const ElementsToolbarTab = (props)=>{
    const elements = elementsItems;
    // console.log('elements',elements);

    const handleDragStart = (event, item, index) => {
        // console.log("handleDragStart", event, item);
        event.dataTransfer.setData('element', JSON.stringify(item));
        // const receivedItemJSON = event.dataTransfer.getData('element');
        // console.log('...receivedItemJSON,',receivedItemJSON);
        // setDraggedItem(item.id);
    };
    const handleDragLeave = (event) => {
        // Use setTimeout to ensure it's removed only after leaving the element
        // console.log('handleDragLeave',event);
        const  eventTarget =  event.target;
        setTimeout(() => {
          eventTarget.classList.remove('dragging-over');
        }, 200); // Adjust the delay if needed
        event.preventDefault();
      };
    
     //console.log('props.pageFrom==',props.pageFrom) 
    return(
        <>
        <div className="row">
            {elements.map((item,itemIndex)=>{
                return(
                    <div className="col-4" key={itemIndex}  >
                        <div 
                            className="card" 
                            draggable
                            onDragStart={(e) => handleDragStart(e, item)}
                            // onDragOver={(e)=>handleDragOver(e,item)}
                            onDragLeave={handleDragLeave}
                            style={{
                            cursor: 'move',
                            // backgroundColor: item === draggedItem ? 'lightblue' : 'white',
                            }}>
                            <div className="card-body text-center">
                                <div className="d-flex align-items-center justify-content-center">
                                    <div>
                                        <Icons iconType={isSet(item.svgIcon,'')} size={24} />
                                        <div className="text-medium pt-1">{item.label}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
        </div>

        {
            props.pageFrom === 'Manual Window'?
            <div className="row">
                {scmTagElements.map((item,itemIndex)=>{
                return(
                    <div className="col-4" key={itemIndex}  >
                        <div 
                            className="card" 
                            draggable
                            onDragStart={(e) => handleDragStart(e, item)}
                            // onDragOver={(e)=>handleDragOver(e,item)}
                            onDragLeave={handleDragLeave}
                            style={{
                            cursor: 'move',
                            // backgroundColor: item === draggedItem ? 'lightblue' : 'white',
                            }}>
                            <div className="card-body text-center">
                                <div className="d-flex align-items-center justify-content-center">
                                    <div>
                                        <Icons iconType={isSet(item.svgIcon,'')} size={24} />
                                        <div className="text-medium pt-1">{item.label}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            })}
            </div>
            :
            null
        }
        </>
    )
}

export default ElementsToolbarTab;